/**
 * Hook for fetching report meta for a doctype
 *
 * Returns categorized fields:
 * - groupable_fields: Fields that can be used for GROUP BY
 * - aggregatable_fields: Fields that support SUM/AVG (numeric)
 * - countable_fields: All non-layout fields (for COUNT)
 */

import { useQuery } from "@tanstack/react-query";
import { erp } from "@/lib/erp";
import type { ReportMeta } from "@/lib/erp/reports";

export function useReportMeta(doctype: string, enabled = true) {
  return useQuery<ReportMeta>({
    queryKey: ["report-meta", doctype],
    queryFn: () => erp.reports.getMeta(doctype),
    staleTime: 5 * 60 * 1000, // 5 minutes - meta rarely changes
    enabled: enabled && !!doctype,
  });
}
